import { navigate } from "hookrouter";
import { getDocs,collection,orderBy,limit,query } from "firebase/firestore";
import React, { useEffect, useState } from "react";


import { stringReducer } from "../../common/helperFunctions";
import explore_event from "../../common/images/explore_events.webp";
import { db } from "../../Firebase/config";

export default function LatestFeaturedEvent() {

  useEffect(() => {
    fetchEvents()
  }, [])

  const [event, setEvent] = useState([])
 
  async function fetchEvents(){
    const docRef = collection(db, "events");
    const docSnap = await getDocs(query(docRef,orderBy("Date", 'desc'),limit(1)));
    let event;
    docSnap.forEach(doc=>{
      event = { id: doc.id, ...doc.data() };
    })
    setEvent(event)
  }

  const getId = (event)=>{
    let id;
    id=`_id/${event.id}`
    console.log(id)
    return id 
  }


  const isEventOver = (eventDate)=>{
    const curr = new Date();
    const event = new Date(eventDate);
    return event < curr;
  }

  return (
    <div className="w-full flex-wrap relative flex bg-white text-black">
      <div class=" px-3 mx-auto w-full max-w-6xl 2xl:max-w-7xl  flex flex-wrap flex-col md:flex-row items-center">
        <div class="w-full md:w-1/2 py-6 text-center">
          <img src={explore_event} alt="" className="w-full  pr-16" />
        </div>
        <div class="flex flex-col w-full md:w-1/2 justify-center items-start text-center md:text-left">
                <p class="uppercase tracking-loose w-full">
                  Hey, The event is UP !!
                </p>
                <h1 class="mt-4 text-3xl sm:text-5xl mx-auto sm:mx-0 font-semibold leading-tight">
                  {event.Title}
                </h1>
                <div className=" flex w-full mt-3 mb-4">
                  <div className="flex mx-auto sm:mx-0">
                    <div className=" w-6 h-4 mr-1  rounded-full bg-blue-600"></div>
                    <div className=" w-6 h-4 rounded-full  bg-green-700"></div>
                  </div>
                </div>
                <p class="leading-normal text-gray-600 text-xl sm:text-2xl mb-8">
                  {event.Primary_description
              ? stringReducer(event.Primary_description, 20)
              : ""}
                </p>
                {event.Price && (
                  <h1 className="text-2xl font-bold leading-tight">
                    Price :{event.Price}
                  </h1>
                )}

                <button
                  // onClick={(_) => navigate("/events/_id/" + event.id)}
                  onClick={() => navigate(`/events/${getId(event)}`)}
                  class="mx-auto lg:mx-0 focus:outline-none outline-none text-white border-b-2 border-blue-600 bg-blue-600 hover:bg-blue-900  transition-all duration-300 font-bold rounded-full  mb-6 py-4 px-8 shadow-lg"
                >
                  {event && (isEventOver(event.Date) ? "View Details" : "Register Now")}
                </button>
              </div>
      </div>
    </div>
  );
}
